// src/client/lib/supabase.ts
// Borrower-surface Supabase client. Distinct storageKey ('thandizo-client-auth')
// keeps borrower sessions isolated from admin sessions in localStorage.
//
// detectSessionInUrl: true — borrower auth uses phone OTP via supabase.auth.verifyOtp
// (no URL hash tokens), but PKCE flow may produce ?code= in the redirect, which
// supabase-js consumes when this flag is on. Setting it to true is harmless on
// pages that don't have a code param.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/lib/database.types';
import { env } from './env';

export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'thandizo-client-auth',
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-client-info': 'thandizo-client/0.1' },
    },
  },
);

export type SupabaseClient = typeof supabase;
